/**
 * @desc Get cookie string from window.document then transform it to a named cookie object
 * @returns {Object} a constructed cookie object
 */
export const getNamedCookies = () => {
    const cookieStr = typeof window !== 'undefined' && window.document && window.document.cookie;
    const namedCookies = {};
    if (cookieStr) {
        const rawCookies = cookieStr.split(';');
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < rawCookies.length; i++) {
            const cookie = rawCookies[i].trim().split('=');
            namedCookies[cookie[0]] = cookie[1] && decodeURIComponent(cookie[1]);
        }
    }
    return namedCookies;
};
